import * as RadixToast from '@radix-ui/react-toast'
import { cn } from '@/lib/utils'
import { type ReactNode } from 'react'

interface ToastProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  variant?: 'default' | 'destructive'
  children?: ReactNode
}

export function Toast({ open, onOpenChange, title, description, variant = 'default' }: ToastProps) {
  return (
    <RadixToast.Provider>
      <RadixToast.Root
        open={open}
        onOpenChange={onOpenChange}
        className={cn(
          'fixed bottom-4 right-4 z-50 flex w-80 flex-col gap-1 rounded-lg border p-4 shadow-lg',
          variant === 'destructive'
            ? 'border-danger bg-danger text-white'
            : 'border-gray-200 bg-white',
        )}
      >
        <RadixToast.Title className="text-sm font-semibold">{title}</RadixToast.Title>
        {description && (
          <RadixToast.Description className="text-xs opacity-80">
            {description}
          </RadixToast.Description>
        )}
      </RadixToast.Root>
      <RadixToast.Viewport />
    </RadixToast.Provider>
  )
}
